import { render, staticRenderFns } from "./TopupHistory.vue?vue&type=template&id=b37abf42&scoped=true&"
import script from "./TopupHistory.vue?vue&type=script&lang=js&"
export * from "./TopupHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b37abf42",
  null
  
)

export default component.exports